import { render } from "./Favorite.vue?vue&type=template&id=21e2b8fa&scoped=true&ts=true"
import script from "./Favorite.vue?vue&type=script&lang=ts"
export * from "./Favorite.vue?vue&type=script&lang=ts"

import "./Favorite.vue?vue&type=style&index=0&id=21e2b8fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e2b8fa"]])

export default __exports__